/**
 * VipManagementService
 * VIP 관리 관련 비즈니스 로직 (등급 표시, 포맷팅 등)
 */
import React from 'react';

export class VipManagementService {
  /**
   * 등급별 아이콘 반환
   */
  getTierIcon(tierLevel: string): React.ReactNode {
    // 아이콘 매핑은 컴포넌트에서 처리 (React 의존성 제거)
    return null;
  }

  /**
   * 등급별 색상 클래스 반환
   */
  getTierColor(tierLevel: string): string {
    const colorMap: Record<string, string> = {
      diamond: 'bg-purple-100 text-purple-800 border-purple-200',
      platinum: 'bg-gray-100 text-gray-800 border-gray-200',
      gold: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      silver: 'bg-gray-50 text-gray-700 border-gray-200',
      bronze: 'bg-amber-100 text-amber-800 border-amber-200',
    };

    return colorMap[tierLevel] || colorMap.bronze;
  }

  /**
   * 통화 포맷 (원화)
   */
  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('ko-KR', {
      style: 'currency',
      currency: 'KRW',
    }).format(amount);
  }

  /**
   * 날짜 포맷 (한국 형식)
   */
  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('ko-KR');
  }

  /**
   * 정렬 옵션 파싱
   */
  parseSortOption(value: string): { sortBy: string; sortOrder: 'asc' | 'desc' } {
    const [sortBy, sortOrder] = value.split('-');
    return { sortBy, sortOrder: sortOrder as 'asc' | 'desc' };
  }

  /**
   * 정렬 옵션 문자열 생성
   */
  createSortOptionValue(sortBy: string, sortOrder: string): string {
    return `${sortBy}-${sortOrder}`;
  }
}

export const vipManagementService = new VipManagementService();
